<template>
  <v-btn :flat="flat" :block="block" class="_btn-room" @click="goToRoom" :ripple="false">
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  name: 'app-btn-chat-room',
  props: {
    flat: Boolean,
    block: Boolean,
    userIds: {
      type: Array,
      required: true
    }
  },
  methods: {
    goToRoom() {
      const token = localStorage.getItem('_token')

      if (!token) {
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
        return
      }

      const authuser = localStorage.getItem('auth._user')
      let userData = null

      try {
        userData = authuser ? JSON.parse(authuser) : null
      } catch (e) {
        console.error("Invalid auth._user data", e)
      }

      if (userData && userData.is_jobprofilevisible === 0) {
        this.showSnackBar('Please complete your <a href="/profile" style="color: white; text-decoration: underline;">profile</a> in order to access NannyGranny content.', 'warning')
        
        return
      }else{

      this.$store.dispatch('chat/GET_ROOM', { user_ids: this.userIds })
        .then(res => {
          this.$router.push(`/chat/${res.data.id}`)
        })
      }
    }

  },
}
</script>

<style lang="stylus" scoped>
  ._btn-room
      height auto !important
      padding 0
      font-size inherit
      color inherit
      margin 0
      &:before
          content none
</style>



// WEBPACK FOOTER //
// src/components/app-buttons/app-btn-chat-room.vue